import { cn } from "@/lib/utils";

// Sits on the top border of its control. The parent carries `group/last-used`;
// the CSS hides the pill the moment the control takes focus, before React
// drops it for the rest of the visit, so it never shows next to a focus ring.
export function LastUsedPill({ className }: { className?: string }) {
  return (
    <span
      data-last-used
      aria-hidden="true"
      className={cn(
        "bg-card text-muted-foreground pointer-events-none absolute top-0 right-3 h-5 -translate-y-1/2 rounded-full border px-2 text-xs leading-[18px] font-medium whitespace-nowrap",
        "group-focus-within/last-used:invisible",
        className,
      )}
    >
      Last used
    </span>
  );
}
